





















import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { ConsumerApplicationStatus } from '@/store/consumer-application/types';
import { Getter } from 'vuex-class';

const namespace = 'consumerApplication';

@Component({
	name: 'processing-modal',

})
export default class ProcessingModal extends Vue {
	@Getter('processingStatus', { namespace }) processingStatus?: ConsumerApplicationStatus;

	data() {
		return {
			status: false,
		};
	}

	@Watch('processingStatus')
	checkStatus(){
		if(this.processingStatus == ConsumerApplicationStatus.PROCESSING){
			this.$data.status = true;
		} else {
			this.$data.status = false;
		}
	}
}
